$('.in-index .products-block').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 3 } }, 
      { breakpoint: 991, settings: { slidesToShow: 2.2, slidesToScroll: 2 } }, 
      { breakpoint: 580, settings: { slidesToShow: 1.2, slidesToScroll: 1, dots: false } },
      { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false} }
    ]
});

$('.type-detail .p-detail>.products-related.products-additional').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 3 } }, 
      { breakpoint: 991, settings: { slidesToShow: 2.2, slidesToScroll: 2 } }, 
      { breakpoint: 580, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
      { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
});

$('.repas .repasInner').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4.4, slidesToScroll: 1 } }, 
      { breakpoint: 992, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2.4, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1.8, slidesToScroll: 1 } }
    ]
});

$('.trustUs .trustUsFeed').slick({
    slidesToShow: 12,
    slidesToScroll: 12,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1440, settings: { slidesToShow: 10, slidesToScroll: 10 } }, 
      { breakpoint: 1200, settings: { slidesToShow: 8, slidesToScroll: 8 } }, 
      { breakpoint: 992, settings: { slidesToShow: 6, slidesToScroll: 6 } },
      { breakpoint: 768, settings: { slidesToShow: 3.6, slidesToScroll: 6 } },
      { breakpoint: 480, settings: { slidesToShow: 3.4, slidesToScroll: 3 } },
      { breakpoint: 340, settings: { slidesToShow: 2.4, slidesToScroll: 2 } }
    ]
});

$('.hpBannerCategoryList').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4.4, slidesToScroll: 1 } }, 
      { breakpoint: 992, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
      { breakpoint: 768, settings: "unslick"}
    ]
});

$('.topBrands .brandFeed').slick({
    slidesToShow: 10,
    slidesToScroll: 10,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1440, settings: { slidesToShow: 10, slidesToScroll: 10 } }, 
      { breakpoint: 1200, settings: { slidesToShow: 8, slidesToScroll: 8 } }, 
      { breakpoint: 992, settings: { slidesToShow: 6, slidesToScroll: 6 } },
      { breakpoint: 768, settings: { slidesToShow: 5, slidesToScroll: 5 } },
      { breakpoint: 480, settings: { slidesToShow: 3.4, slidesToScroll: 3 } },
      { breakpoint: 340, settings: { slidesToShow: 2.4, slidesToScroll: 2 } }
    ]
});


$('.type-detail #productsAlternative .products').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 3 } }, 
      { breakpoint: 991, settings: { slidesToShow: 2.2, slidesToScroll: 2 } }, 
      { breakpoint: 580, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
      { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
});

